import './RichNoteEditor.css'; 

import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { generateClassName } from '../../../b2b-common/helpers';

// Define custom toolbar options
const toolbarOptions = [
    ['bold', 'italic', 'underline'],        // Formatting options
    [{ 'header': [1, 2, false] }],          // Header levels
    [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
    ['clean']                               // Remove formatting
];

const RichNoteEditor = ({ value, readOnly = false, onChange, className = null }) => {
    const [content, setContent] = useState(value || '');

    useEffect(() => {
        if (value) {
            setContent(value);
        }
    }, [value]);

    const handleContentChange = (newContent) => {
        setContent(newContent);
        if (onChange) {
            onChange(newContent);
        }
    };

    return (
        !readOnly ? (
            <ReactQuill
                theme="snow"
                value={content}
                onChange={handleContentChange}
                modules={{ toolbar: toolbarOptions }}
                style={{ minHeight: '200px' }}
                className={generateClassName('B2BRichNoteEditor', '', className)}
            />
        ) : (
            <div className='B2BRichNoteEditor-content-readOnly' dangerouslySetInnerHTML={{ __html: content }} />
        )
    );
};

export default RichNoteEditor;